import React from 'react';
import { Colors as colors } from '../../constants/Colors.js';
import { formatNoticiaImagenOtherAttribution, resolveNoticiaImagenCredit } from '../../lib/noticiasImagenCredit.js';

/**
 * Pie de imagen según fuente: Pexels, DreamVinyl (propia) u otra procedencia manual.
 * @param {{ noticia: { imagen_url?: string|null, metadata?: object|null }, variant?: 'public'|'admin' }} props
 */
export default function NoticiaImagenCredit({ noticia, variant = 'public' }) {
  const imagenUrl = String(noticia?.imagen_url ?? '').trim();
  if (!imagenUrl) return null;

  const credit = resolveNoticiaImagenCredit(noticia);
  if (!credit.type) return null;

  if (credit.type === 'other') {
    return (
      <div
        style={{
          fontSize: variant === 'admin' ? 9 : 8,
          lineHeight: 1.35,
          textAlign: 'right',
          padding: variant === 'admin' ? '6px 12px 8px' : '5px 10px 7px',
          color: 'rgba(255,255,255,0.32)',
          background: 'rgba(10,10,15,0.92)',
        }}
      >
        {formatNoticiaImagenOtherAttribution(credit.attributionText)}
      </div>
    );
  }

  if (credit.type === 'pexels') {
    return (
      <div
        style={{
          fontSize: variant === 'admin' ? 9 : 8,
          lineHeight: 1.35,
          textAlign: 'right',
          padding: variant === 'admin' ? '6px 12px 8px' : '5px 10px 7px',
          color: 'rgba(255,255,255,0.32)',
          background: 'rgba(10,10,15,0.92)',
        }}
      >
        Foto vía{' '}
        <a
          href={credit.pexelsUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'rgba(255,255,255,0.42)', textDecoration: 'underline', textUnderlineOffset: '2px' }}
        >
          Pexels
        </a>
      </div>
    );
  }

  return (
    <div
      style={{
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        textAlign: 'right',
        padding: '10px 14px 12px',
        marginTop: 0,
        borderTop: '1px solid rgba(200,168,75,0.28)',
        background: 'linear-gradient(180deg, rgba(200,168,75,0.12) 0%, rgba(10,10,15,0.96) 65%)',
        color: colors.gold,
        textShadow: '0 0 18px rgba(200,168,75,0.35), 0 1px 2px rgba(0,0,0,0.9)',
      }}
    >
      <span style={{ color: colors.goldLight }}>By DreamVinyl</span>
    </div>
  );
}
